/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-unresolved */
import { memo, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import store from "src/redux/store";
import { setLoanDetails } from "src/redux/Actions/loanDetails";
import { useDispatch } from "react-redux";
import {
  SET_TOAST_ERROR,
  setGeneralDetails,
  setRecalculateStatus,
  setStepDetails
} from "src/redux/Actions/common";
import { loanDetailsUpdate, updateExistingPolicyDetails } from "src/services/FormDetails";
import { useMutation } from "react-query";
import CustomBackDrop from "src/shared/CustomBackDrop";
import { getMasterPolicy } from "src/services/FormDetails/CreateLead";
import { calcAgeFromToday } from "src/helpers/FormDetails/ProposalDetails/resources";
import { prepareRiderPayload } from "src/helpers/FormDetails/resources";
import { useRiderDetailsMutation } from "src/utils/hooks/useSaveRiderMutation";
import LoanForm from "./LoanForm";
import {
  existingLifeCoverInitialValuesObject,
  initialValues,
  validationSchema
} from "../../../helpers/FormDetails/LoanDetails";
import CustomModal from "../../../shared/CustomModal";
import DetailsHeading from "../../../shared/DetailsHeading";
import ExistingLifeCoverDetails from "./ExistingLifeCoverDetails";

function LoanDetails() {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const dispatch = useDispatch();
  const [existingPolicy, setExistingPolicy] = useState(loanDetails.existingPolicy);
  const leadId = useAppSelector((state) => state.common.leadId);
  const memberId = useAppSelector((state) => state?.proposerDetails?.memberId);
  const [noOfCoBorrowersError, setNoOfCoBorrowersError] = useState("");
  const parentStepNumber = useAppSelector((state) => state.stepDetails.parentStepNo);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const isRecalculateDone = useAppSelector((state) => state.common.isRecalculateDone);
  const coverOption = useAppSelector((state) => state?.loanDetails?.plan?.coverOptionCode);
  const isRiderOpted = useAppSelector((state) => state?.loanDetails?.isRiderSelectionLocked);

  const { mutate, isLoading: isLoanDataUpdating } = useMutation(loanDetailsUpdate, {
    onSuccess: () => {
      if (isRiderOpted) {
        const riderPayload = prepareRiderPayload(leadId, formik?.values?.riderDetails);
        mutateRiderDetails(riderPayload);
      }
    },
    onError: (error) => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 2000,
          message: error
        })
      );
    }
  });

  const productId = useAppSelector((state) => state.common.productId);

  const partnerId = useAppSelector((state) => state.common.leadDetails?.partnerId);

  const isStaffMember = useAppSelector((state: any) => state.generalDetails?.isStaff);

  const lifeInsurerDob = useAppSelector((state) => state.proposerDetails?.general?.dob);

  const lifeInsurerAge = calcAgeFromToday(lifeInsurerDob!);

  const { mutate: fetchMasterPolicy } = useMutation(
    async (payload: any) =>
      getMasterPolicy(
        payload?.productId,
        payload?.partnerId,
        payload?.isStaffMember,
        payload?.lifeInsurerAge,
        payload?.loanCategory,
        payload?.coverOption
      ),
    {
      retry: false
    }
  );

  const { mutate: updateExistingPolicyDetials } = useMutation(updateExistingPolicyDetails);
  const loanAmt = useAppSelector((state) => state.masterdata_reducer?.loanAmount) || {};
  const { loanDetails: loanDetailsMefFields, planDetails: planDetailsMefFields } =
    useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};

  const addRiders = useAppSelector((state) => state.generalDetails?.addRiders);
  const riderEligibility = useAppSelector((state) => state.masterdata_reducer?.riderEligibility);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: loanDetails,
    validationSchema: validationSchema(
      noOfCoBorrowersError,
      productId,
      coverOption!,
      partnerId,
      {
        loanDetailsMefFields,
        planDetailsMefFields
      },
      addRiders,
      riderEligibility,
      loanAmt
    ),
    onSubmit: async (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        if (!isRecalculateDone) {
          store.dispatch(
            SET_TOAST_ERROR({
              error: true,
              duration: 3000,
              message: "Please Recalculate Premium To Proceed"
            })
          );
          return;
        }
        if (!Number(fieldValues?.premiumDetails?.totalPayment)) {
          store.dispatch(
            SET_TOAST_ERROR({
              error: true,
              duration: 3000,
              message: "Cannot proceed with premium Rs. 0"
            })
          );
          return;
        }

        fetchMasterPolicy(
          {
            productId,
            partnerId,
            isStaffMember,
            lifeInsurerAge,
            loanCategory: fieldValues?.loan?.loanTypeCode!,
            coverOption: fieldValues?.loan?.lifeCoverOptionCode
          },
          {
            onSuccess: async ({ data, resolve }) => {
              await Promise.allSettled([
                mutate({
                  values: fieldValues,
                  section: "loan",
                  leadId,
                  masterPolicyNumber: data?.masterPolicyNumber
                }),
                updateExistingPolicyDetials({
                  memberId,
                  values: fieldValues
                })
              ])
                .then(() => {
                  store.dispatch(setLoanDetails(fieldValues));
                  store.dispatch(
                    setGeneralDetails({
                      ...fieldValues,
                      masterPolicyNumber: data?.masterPolicyNumber
                    })
                  );
                  store.dispatch(setRecalculateStatus(false));
                  dispatch(setStepDetails({ parentStepNo: parentStepNumber + 1 }));
                  window.scrollTo(0, 0);
                })
                .catch(() => {
                  store.dispatch(
                    SET_TOAST_ERROR({
                      error: true,
                      duration: 2000,
                      message: "Please Try Again."
                    })
                  );
                });
            }
          }
        );
      }
    }
  });

  const { mutate: mutateRiderDetails, isLoading: isRiderLoading } = useRiderDetailsMutation(
    formik?.setFieldValue,
    formik?.values?.riderDetails
  );

  useEffect(() => {
    formik.setValues(loanDetails || initialValues);
  }, [loanDetails]);

  useEffect(() => {
    formik.setValues({ ...formik.values, existingPolicy });
  }, [existingPolicy]);

  const handleExistingLifeCoverAddButton = () => {
    setExistingPolicy({
      ...formik.values.existingPolicy,
      existingPolicyDetails: [
        ...formik.values?.existingPolicy?.existingPolicyDetails,
        existingLifeCoverInitialValuesObject
      ]
    });
  };

  const handleExistingLifeCoverRemoveButton = (existingCoverIndex: number) => {
    setExistingPolicy({
      ...formik.values.existingPolicy,
      existingPolicyDetails: formik.values?.existingPolicy?.existingPolicyDetails.filter(
        (_, index) => index !== existingCoverIndex
      )
    });
  };

  console.log("loan details formik", formik?.values, formik?.errors);

  useEffect(() => {
    if (!formik.values.existingPolicy?.existingLifeCover) {
      setExistingPolicy({
        ...formik.values.existingPolicy,
        existingPolicyDetails: [existingLifeCoverInitialValuesObject]
      });
    }
  }, [formik.values.existingPolicy?.existingLifeCover]);

  useEffect(() => {
    if (Number.isNaN(+formik.values.loan?.noOfCoBorrowers))
      setNoOfCoBorrowersError("Only numbers are allowed");
    else if (
      formik.values.plan?.coverOption === "Proportionate Cover" &&
      formik.values.loan?.noOfCoBorrowers > 5
    )
      setNoOfCoBorrowersError("Only 5 members are allowed");
    else if (
      formik.values.plan?.coverOption !== "Proportionate Cover" &&
      formik.values.loan?.noOfCoBorrowers > 9
    )
      setNoOfCoBorrowersError("Only 9 members are allowed");
    else setNoOfCoBorrowersError("");
  }, [formik.values.plan?.coverOption, formik.values.loan?.noOfCoBorrowers]);

  const handleLoanDetailsForm = () => {
    setModalOpen(!formik.isValid);
    formik.handleSubmit();
  };

  useEffect(() => {
    store.dispatch(setRecalculateStatus(false));
  }, [
    formik.values?.loan,
    formik.values?.premiumFunding,
    formik.values?.plan?.coverOptionCode,
    formik.values?.plan?.coverTermCode,
    formik.values?.plan?.premiumPaymentTermCode,
    formik.values?.premiumDetails?.premiumModeCode
  ]);
  return (
    <>
      <CustomBackDrop open={isLoanDataUpdating || isRiderLoading} />
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="min-h-screen bg-whiteSmoke pt-8 pb-19.5">
        <div className="md:w-805/1000 mx-auto bg-white pt-8.5 pb-10 rounded-1.5xl">
          <div className="pr-10 pl-10.25">
            <DetailsHeading label="Loan and Plan Details" />
          </div>
          <div className="bg-whiteSmoke">
            <div className="pl-10.25 bg-white pr-10 py-8 rounded-b-1.5xl">
              <LoanForm formik={formik} />
            </div>
            <div className="w-full h-6" />
            <div className="pl-10.25 bg-white pr-10 pt-8 rounded-t-1.5xl">
              <ExistingLifeCoverDetails
                formik={formik}
                existingLifeCoverLength={existingPolicy?.existingPolicyDetails?.length}
                handleExistingLifeCoverAddButton={handleExistingLifeCoverAddButton}
                handleExistingLifeCoverRemoveButton={handleExistingLifeCoverRemoveButton}
              />
              <div className="flex justify-center mt-10">
                <Button
                  variant="outlined"
                  classes={{ outlined: "!rounded-lg" }}
                  onClick={() => {
                    dispatch(setStepDetails({ parentStepNo: parentStepNumber - 1 }));
                    window.scrollTo(0, 0);
                  }}
                  className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  classes={{ contained: "!rounded-lg" }}
                  onClick={handleLoanDetailsForm}
                  className="!uppercase h-13 w-37.5"
                >
                  NEXT
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(LoanDetails);
